import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { OsAuthProvider } from '@os/auth-client/react';
import '@os/ui/styles.css';
import { ApiError } from './api';
import { auth } from './auth';
import { router } from './router';

// Retry only server/network failures (never 4xx), at most twice — same policy as the apps (taxledger providers.tsx).
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2, refetchOnWindowFocus: false } } });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <OsAuthProvider auth={auth}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </OsAuthProvider>
  </React.StrictMode>,
);
